import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';

export default class BookingBookedWorkersViewModel {
    selectedBookingRole: BookingRoleDto;
    selectedShift: ShiftDto = new ShiftDto();
    shifts: ShiftDto[] = []
    timesheets: TimesheetDto[] = [];    
}